function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import styled, { css } from "styled-components";
import React, { memo, useContext } from "react";
import { selectionBackground } from "../../../helpers/background";
import ClipContext from "./ClipContext";
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-109n64h-0"
})(["", " position:absolute;top:0;left:0;bottom:0;", ""], selectionBackground, ({
  error
}) => error && css(["background-color:rgba(255,0,0,0.2);"]));
const Selection = /*#__PURE__*/memo(({
  end,
  start,
  ...props
}) => {
  const clip = useContext(ClipContext);
  const length = end - start;
  const clipLength = clip.end - clip.start;
  const scale = length / clipLength;
  const left = (clip.start - start) / length * 100;
  const width = scale * 100;
  return /*#__PURE__*/React.createElement(Root, _extends({}, props, {
    style: {
      width: `${width}%`,
      transform: `translate3d(${-left}%,0,0)`
    }
  }));
});
export default Selection;
//# sourceMappingURL=Selection.js.map